import { configureStore } from '@reduxjs/toolkit';
import { CurriedGetDefaultMiddleware } from '@reduxjs/toolkit/dist/getDefaultMiddleware';

import { errorMiddleware, successMiddleware } from 'store/middlewares';
import { rootReducer } from 'store/rootReducer';

import { LMApi } from 'api/LMApi';
import { bebyggelseApiRTK } from 'api/bebyggelseApiRTK';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware: CurriedGetDefaultMiddleware) =>
    getDefaultMiddleware().concat(errorMiddleware, successMiddleware, bebyggelseApiRTK.middleware, LMApi.middleware)
});

// Infer the `RootState` and `AppDispatch` types from the store itself
// Inferred type: {posts: PostsState, comments: CommentsState, users:  UsersState}
export type AppDispatch = typeof store.dispatch;
